import { createFileRoute } from "@tanstack/react-router";

import { getArticles } from "@/lib/articles";
import { getJobPostings } from "@/lib/jobPostings";
import { HomePageContent } from "../index";

export const Route = createFileRoute("/en/")({
	loader: async () => {
		const [articles, positions] = await Promise.all([
			getArticles("en"),
			getJobPostings("en"),
		]);
		return { articles, positions };
	},
	headers: () => ({
		"Cache-Control":
			"public, max-age=0, s-maxage=3600, stale-while-revalidate=86400",
	}),
	head: () => ({
		meta: [
			{ title: "Makedonijaturist AD | Hotels in Skopje" },
			{
				name: "description",
				content:
					"Makedonijaturist AD - The largest hotel group in Skopje. Holiday Inn, Hotel Karposh, Hotel Turist, Hotel Bellevue. Local heart, urban comfort.",
			},
		],
		links: [
			{
				rel: "canonical",
				href: "https://makedonijaturist.com.mk/en",
			},
		],
		scripts: [
			{
				type: "application/ld+json",
				children: JSON.stringify({
					"@context": "https://schema.org",
					"@type": "Organization",
					name: "Makedonijaturist AD",
					url: "https://makedonijaturist.com.mk/en",
					logo: "https://makedonijaturist.com.mk/logo512.png",
					contactPoint: {
						"@type": "ContactPoint",
						telephone: "+389-2-3114-105",
						contactType: "customer service",
					},
				}),
			},
		],
	}),
	component: EnHomePage,
});

function EnHomePage() {
	const { articles, positions } = Route.useLoaderData();
	return <HomePageContent articles={articles} positions={positions} />;
}
